/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: index.ts
 * Class: index.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { Module } from 'vuex';
import { LandingpageState } from './types';
import { RootState } from '../types';
import { mutations } from './mutations';
import { getters } from './getters';

export const state: LandingpageState = {
  landingPage: {
    data: undefined,
    error: undefined,
    status: undefined,
  },
  orderWidget: {
    data: undefined,
    error: undefined,
    status: undefined,
  },
  activeOrderConfiguration: undefined,
};

const namespaced = true;

export const landingPage: Module<LandingpageState, RootState> = {
  namespaced,
  state,
  mutations,
  getters,
};
